import { GetProfileByIdRes } from "@/api/profiles";
import { Profile } from "@/types/profile";
import { AxiosResponse } from "axios";

export class ProfileTransformer {
    static convertNetworkResponseFromGetProfileById(res: AxiosResponse<GetProfileByIdRes>): Profile {
        return res
            .data
            .data
            .profile
    }
}
